import { render } from "./UpgradeButton.vue?vue&type=template&id=44cfb69e&scoped=true"
import script from "./UpgradeButton.vue?vue&type=script&lang=js"
export * from "./UpgradeButton.vue?vue&type=script&lang=js"

import "./UpgradeButton.vue?vue&type=style&index=0&id=44cfb69e&scoped=true&lang=css"

import exportComponent from "/Users/numeria/Desktop/innopearl-partner-plus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cfb69e"]])

export default __exports__